// 使用普通导入语句导入所有路由组件
import MainPage from "../views/MainPage.vue";
import LoginFromWeChat from "../views/account/LoginFromWeChat.vue";
import BindToPhone from "../views/account/BindToPhone.vue";
import HomePage from "../views/HomePage.vue";

// 然后，定义路由数组，使用已经定义的变量来指定组件
const mainRoutes = [
  {
    path: "/",
    name: "main",
    component: MainPage,
  },
  {
    path: "/wechatLogin",
    name: "wechatLogin",
    component: LoginFromWeChat,
  },
  {
    path: "/bindToPhone",
    name: "bindToPhone",
    component: BindToPhone,
  },
  {
    path: "/home",
    name: "home",
    component: HomePage,
  },
  // 注意：MyBowlerInfo和MyMatchInfo组件在当前路由定义中没有被使用
  // 如果它们在其他地方被使用，请保留这些导入语句
  // 否则，可以考虑移除它们以清理代码
];

export default mainRoutes;
